module.exports = __webpack_public_path__ + "e0106718/img/settings-icon.121d9519.svg";